import type { WorkspaceResponseV2 } from '@emma/api_client/types';
import { Box, Card, Link, Text, Tooltip, useToast } from '@lego/klik-ui';
import { useNavigate } from 'react-router-dom';
import { paths } from '@/utility/global_paths';
import { ToastOptions } from '@/utility/ToastOptions';
import { TextHeader } from '../common';

type Props = {
  workspace: WorkspaceResponseV2;
};

export const WorkspaceCard = (props: Props) => {
  const toast = useToast();
  const navigate = useNavigate();

  const handleClick = () => {
    if (props.workspace.state !== 'READY') {
      toast(
        ToastOptions.error('Workspace is not ready', 'Please wait for the workspace to be ready')
      );
    } else {
      navigate(paths.workspaceById(props.workspace.id));
    }
  };

  return (
    <Card
      boxShadow={'md'}
      cursor="pointer"
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'space-between'}
      onClick={handleClick}
      px={8}
      py={5}
      rounded={'md'}
      width="md"
    >
      <Box>
        <TextHeader mb={1} tagLevel="h4" title={props.workspace.name} />
        <Text>{props.workspace.description}</Text>
      </Box>
      <Box>
        <Text display="flex" my={3}>
          Owner:
          <Link
            href={`https://omnisight.thelegogroup.com/architecture-gateway/products/${props.workspace.enterpriseArchitectureProductId}/overview`}
            isExternal
            ml={1}
            onClick={(event: React.MouseEvent<HTMLAnchorElement>) => event.stopPropagation()}
            overflow="hidden"
            padding={0}
          >
            Enterprise Architecture Product Link
          </Link>
        </Text>
        <Tooltip label={`Workspace is in ${props.workspace.state} State`} placement="bottom">
          <Text
            color={
              props.workspace.state === 'READY'
                ? 'green'
                : props.workspace.state === 'CREATED'
                  ? 'slate.400'
                  : props.workspace.state === 'PENDING'
                    ? 'warning.400'
                    : 'red'
            }
            fontWeight={'bold'}
            textAlign={'center'}
            width={'100%'}
          >
            {props.workspace.state}
          </Text>
        </Tooltip>
      </Box>
    </Card>
  );
};
